export default {
  menu: {
    users: '用户管理',
    roles: '角色管理',
    agents: 'Agent管理'
  },
  user: {
    list: '用户列表',
    search: {
      quickSearch: '快速搜索',
      placeholder: '手机号/邮箱/昵称/真实姓名',
      roles: '角色',
      registerTime: '注册时间'
    },
    group: {
      all: '全部',
      admin: '管理员',
      user: '用户',
      guest: '游客'
    },
    fields: {
      id: '编号',
      name: '姓名',
      contact: '联系方式',
      phone: '手机号',
      email: '邮箱',
      realname: '真实姓名',
      roles: '角色',
      unnamed: '暂无'
    },
    detail: {
      basicInfo: '基本信息',
      contactInfo: '联系方式',
      roleInfo: '角色信息',
      labels: {
        userName: '用户名称',
        userId: '用户ID',
        phone: '手机号',
        email: '邮箱',
        createdAt: '创建时间',
        updatedAt: '更新时间'
      }
    },
    form: {
      labels: {
        email: '邮箱',
        name: '姓名',
        phone: '手机号',
        password: '密码',
        passwordConfirmation: '密码确认',
        roles: '角色'
      },
      placeholders: {
        email: '请填写邮箱',
        name: '请填写姓名',
        phone: '请填写手机号',
        password: '请填写密码',
        passwordConfirmation: '请填写密码确认',
        roles: '请选择角色'
      },
      validation: {
        email: {
          required: '请填写邮箱',
          invalid: '请输入有效的邮箱地址'
        },
        name: {
          required: '请填写姓名'
        },
        phone: {
          required: '请填写手机号',
          invalid: '请输入正确的手机号'
        },
        password: {
          required: '请填写密码',
          minLength: '密码长度不能小于6位'
        },
        passwordConfirmation: {
          required: '请填写密码确认',
          notMatch: '两次输入的密码不一致'
        },
        roles: {
          required: '请选择角色'
        }
      }
    }
  },
  role: {
    list: '角色列表',
    search: {
      quickSearch: '快速搜索',
      placeholder: '角色名称/描述'
    },
    fields: {
      name: '角色名称',
      permissions: '权限',
      type: '类型',
      createdAt: '创建时间'
    },
    detail: {
      basicInfo: '基本信息',
      permissionInfo: '权限信息',
      labels: {
        roleName: '角色名称',
        roleId: '角色ID',
        description: '描述',
        createdAt: '创建时间',
        updatedAt: '更新时间'
      }
    },
    form: {
      labels: {
        name: '角色名称',
        description: '描述',
        permissions: '权限'
      },
      placeholders: {
        name: '请填写角色名称',
        description: '请填写角色描述',
        permissions: '请选择权限'
      },
      validation: {
        name: {
          required: '请填写角色名称'
        },
        permissions: {
          required: '请选择权限'
        }
      }
    }
  },
  aigc: {
    agent: {
      list: 'Agent列表',
      add: '新建Agent',
      edit: '编辑Agent',
      search: {
        quickSearch: '快速搜索',
        placeholder: 'Agent名称/描述',
        type: '类型',
        selectType: '请选择类型'
      },
      fields: {
        basic: '基本信息',
        provider: '提供商',
        model: '模型',
        type: '类型',
        name: '名称',
        createdAt: '创建时间',
        description: '描述',
        status: '状态'
      },
      name: '名称',
      namePlaceholder: '请填写名称',
      nameRequired: '请填写名称',
      gender: '性别',
      genderPlaceholder: '请选择性别',
      genderRequired: '请选择性别',
      genders: {
        male: '男',
        female: '女',
        neutral: '中性'
      },
      voice: '声音',
      voicePlaceholder: '请选择声音',
      voiceRequired: '请选择声音',
      provider: '提供商',
      providerRequired: '请选择提供商',
      selectProvider: '请选择提供商',
      selectModel: '请选择模型',
      prompt: 'Prompt 设置',
      promptRequired: '请输入 Prompt',
      promptPlaceholder: '请输入 AI 助手的 Prompt 设置，这将决定 AI 助手的行为和个性...',
      providers: {
        all: '全部',
        openai: 'OpenAI',
        anthropic: 'Anthropic',
        google: 'Google',
        mistral: 'Mistral AI',
        chatglm: '智谱 AI',
        deepseek: 'DeepSeek',
        qwen: '阿里云',
        baichuan: '百川智能',
        ollama: 'Ollama',
        spark: '科大讯飞'
      },
      models: {
        'gpt-4o-mini': 'GPT-4 Omega Mini',
        'gpt-4o': 'GPT-4 Omega',
        'claude-3-5-sonnet-20240620': 'Claude3.5 Sonnet (2024.06)',
        'claude-3-5-sonnet-20240229': 'Claude3.5 Sonnet (2024.02)',
        'mixtral-8x7b-32768': 'Mixtral 8x7B-32K',
        'glm-3.5-8b': 'ChatGLM3.5 8B',
        'deepseek-chat': 'DeepSeek Chat',
        'deepseek-reasoner': 'DeepSeek Reasoner',
        'qwen-turbo': '通义千问',
        'qwen-plus': '通义千问 Plus',
        'qwen-2.5-72b': '通义千问2.5 72B',
        'baichuan-2-72b': '百川2 72B',
        'llama3-8b': 'Llama3 8B',
        lite: '星火大模型Lite',
        generalv3: '星火大模型V3',
        'pro-128k': '星火大模型Pro(128K)',
        'generalv3.5': '星火大模型V3.5',
        'max-32k': '星火大模型Max (32K)',
        '4.0Ultra': '星火大模型4.0 Ultra'
      }
    },
    tag: {
      list: '标签列表',
      add: '新建标签',
      edit: '编辑标签',
      fields: {
        name: '名称',
        taggingsCount: '使用次数'
      },
      namePlaceholder: '请输入标签名称',
      nameRequired: '请填写标签名称'
    }
  },
  home: {
    dashboard: {
      stats: {
        totalUsers: '总用户数',
        activeToday: '今日活跃',
        totalRevenue: '总收入',
        conversionRate: '转化率',
        comparedToLastWeek: '较上周'
      },
      charts: {
        visitTrend: '访问趋势',
        userDistribution: '用户分布',
        timeRanges: {
          week: '本周',
          month: '本月',
          year: '全年'
        },
        distributionTypes: {
          type: '类型',
          region: '地区'
        },
        userTypes: {
          newUsers: '新用户',
          activeUsers: '活跃用户',
          inactiveUsers: '沉默用户'
        },
        regions: {
          east: '华东',
          north: '华北',
          south: '华南',
          west: '西部',
          northeast: '东北'
        },
        weekdays: {
          monday: '周一',
          tuesday: '周二',
          wednesday: '周三',
          thursday: '周四',
          friday: '周五',
          saturday: '周六',
          sunday: '周日'
        },
        chartLabels: {
          visits: '访问量',
          userDistribution: '用户分布'
        }
      },
      activities: {
        title: '最近活动',
        viewAll: '查看全部',
        noActivities: '暂无活动记录'
      }
    }
  },
  common: {
    id: '编号',
    type: '类型',
    name: '名称',
    createdAt: '创建时间',
    operation: '操作',
    edit: '编辑',
    show: '查看',
    confirmDelete: '确定要删除吗？',
    delete: '删除',
    save: '保存',
    cancel: '取消',
    confirm: '确认',
    back: '返回',
    search: '搜索',
    reset: '重置',
    loading: '加载中...',
    noData: '暂无数据',
    success: '操作成功',
    error: '操作失败',
    deleteConfirm: '确定要删除吗？',
    total: '共 {total} 条',
    basicInfo: '基本信息',
    contactInfo: '联系方式',
    close: '关闭',
    submit: '提交',
    required: '必填项',
    pleaseSelect: '请选择',
    pleaseInput: '请输入'
  }
}
